import Container from 'react-bootstrap/Container';
import 'bootstrap/dist/css/bootstrap.min.css';
import "./custom.scss";

function UnderConstructionPage() {


    return (
        <div id="root">
            <main className='main-container'>
                <Container className='custom-container pb-3'>
                <div className="under-construction">
                    <h2 className='under-construction-color '>
                        H εφαρμογή <strong>teachers-app.com</strong> βρίσκεται σε προγραμματισμένη αναβάθμιση των δεδομένων της από τις <strong>15.00</strong> μέχρι τις <strong>17.00</strong>.<br/><br/>
                        Ευχαριστούμε για την κατανόηση.
                    </h2>
                </div>
                
                </Container>
            </main>
        
        </div>    
    );
}

export default UnderConstructionPage;